import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import Navbar from "../../../globals/components/Navbar";
import { BondRetrievalUnderwritingBanner } from "./components/bondRetrieval/BondRetrievalUnderwritingBanner";

/**
 * Shared page chrome for court bond retrieve screens (Phase 14).
 * Form sections and workflow UI are passed as children.
 */
export function BondRetrievalPageLayout({
  title,
  data,
  role,
  isLoading,
  children,
  footer,
  overlays,
}) {
  return (
    <>
      <Navbar />
      <Box className="p-6 max-w-4xl mx-auto">
        <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: "bold" }}>
          {title}
          {data?.is_guest ? " (Guest)" : ""}
        </Typography>
        <BondRetrievalUnderwritingBanner data={data} role={role} />
        {children}
        {footer}
      </Box>
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {overlays}
    </>
  );
}

export default BondRetrievalPageLayout;
